import { atom } from "recoil";
import { IVendorConfigurationRepository, SelectedRowsToDelete } from "../type";

export const addAutopay = atom({
  key: "addAutopay",
  default: false,
});

export const savingAutopay = atom({
  key: "savingAutopay",
  default: false,
});

export const autoPayFilterText = atom({
  key: "autoPayFilterText",
  default: "",
});

export const rowForAutopay = atom<
  IVendorConfigurationRepository | undefined
>({
  key: "rowForAutopay",
  default: undefined,
});

export const selectedRowsAutopay = atom<SelectedRowsToDelete>({
  key: "selectedRowsAutopay",
  default: [],
});

export const editAutopayName = atom({
  key: "editAutopayName",
  default: false,
});

export const editRowAutopay = atom({
  key: "editRowAutopay",
  default: [],
});

export const hasAutopay = atom({
  key: "hasAutopay",
  default: false,
});

export const autoPayFetching = atom({
  key: "autoPayFetching",
  default: true,
});
export const autoPayReFetching = atom({
  key: "autoPayReFetching",
  default: false,
});
